// extracted by mini-css-extract-plugin
export default {"listItemSelected":"SearchHistoryList_listItemSelected__-zu2w"};